
export default function ClaimsProcess() {
  return (
    <section id="claims-process" className="py-32 bg-gradient-to-br from-white via-[#FFF1F2] to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-20 right-10 w-80 h-80 bg-[#EC4899]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-80 h-80 bg-[#EC4899]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2 bg-[#EC4899]/10 text-[#EC4899] text-sm font-semibold rounded-full mb-6">
            CLAIMS PROCESS
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            손해사정 프로세스
          </h2>
          <p>
            전문 손해사정사가 체계적이고 공정하게 사고를 처리합니다
          </p>
        </div>

        {/* Main Image */}
        <div className="mb-20 relative group">
          <div className="absolute inset-0 bg-gradient-to-br from-[#EC4899]/20 to-transparent rounded-3xl transform -rotate-2 group-hover:rotate-0 transition-transform duration-500"></div>
          <img 
            src="https://public.readdy.ai/ai/img_res/e3cea511bd13a6a3052b8607927cda7b.jpg"
            alt="손해사정 프로세스"
            className="relative rounded-3xl shadow-2xl w-full h-[400px] object-cover transform group-hover:scale-[1.02] transition-transform duration-500"
          />
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {/* Step 1 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#EC4899]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EC4899] to-[#DB2777] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">사고 접수</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>즉시 신고</p>
                  <p>사고 발생 즉시 보험사에 신고</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-file-text-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>기본 정보 수집</p>
                  <p>사고 일시, 장소, 상황 파악</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-user-add-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>담당자 배정</p>
                  <p>전담 손해사정사 즉시 배정</p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#EC4899]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EC4899] to-[#DB2777] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">현장 조사</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>현장 방문</p>
                  <p>사고 현장 직접 방문 조사</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-camera-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>증거 수집</p>
                  <p>사진, 영상, 문서 등 증거 확보</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-team-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>관계자 면담</p>
                  <p>목격자 및 관련자 진술 청취</p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#EC4899]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EC4899] to-[#DB2777] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">의료 검토</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-hospital-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>진료 기록 분석</p>
                  <p>의료 기록 및 진단서 검토</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-stethoscope-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>전문의 자문</p>
                  <p>필요시 의료 전문가 의견 청취</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-heart-pulse-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>인과관계 파악</p>
                  <p>사고와 손해의 인과관계 분석</p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#EC4899]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EC4899] to-[#DB2777] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                <span className="text-2xl font-bold text-white">4</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">책임 판단</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-scales-3-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>과실 비율 산정</p>
                  <p>공정한 과실 비율 결정</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-file-shield-2-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>법률 검토</p>
                  <p>관련 법규 및 판례 검토</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-article-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>보고서 작성</p>
                  <p>상세한 손해사정 보고서 작성</p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 5 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#EC4899]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EC4899] to-[#DB2777] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                <span className="text-2xl font-bold text-white">5</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">보상 협의</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-calculator-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>보상액 산정</p>
                  <p>적정 보상금액 계산</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-discuss-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>당사자 협의</p>
                  <p>피해자 및 시설과 협의</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-file-edit-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>합의서 작성</p>
                  <p>보상 합의서 작성 및 서명</p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 6 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#EC4899]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#EC4899] to-[#DB2777] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                <span className="text-2xl font-bold text-white">6</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">보험금 지급</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>최종 승인</p>
                  <p>보험금 지급 최종 승인</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-bank-card-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>신속 지급</p>
                  <p>승인 후 즉시 보험금 지급</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-file-list-3-line text-[#EC4899] text-lg mt-1"></i>
                <div>
                  <p>사후 관리</p>
                  <p>지급 후 사후 관리 및 모니터링</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="bg-gradient-to-br from-white to-[#FFF1F2] rounded-3xl p-12 shadow-xl border-2 border-[#EC4899]/20">
          <h3 className="text-3xl font-bold text-gray-900 mb-12 text-center">케어인슈 손해사정의 특징</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center group hover:-translate-y-2 transition-all duration-300">
              <div className="w-20 h-20 bg-[#EC4899]/10 rounded-3xl flex items-center justify-center mb-6 mx-auto group-hover:bg-[#EC4899]/20 transition-colors">
                <i className="ri-user-star-line text-4xl text-[#EC4899]"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">전문성</h4>
              <p>
                장기요양기관 전문 손해사정사가<br />직접 사고를 처리합니다
              </p>
            </div>
            <div className="text-center group hover:-translate-y-2 transition-all duration-300">
              <div className="w-20 h-20 bg-[#EC4899]/10 rounded-3xl flex items-center justify-center mb-6 mx-auto group-hover:bg-[#EC4899]/20 transition-colors">
                <i className="ri-time-line text-4xl text-[#EC4899]"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">신속성</h4>
              <p>
                사고 접수 후 신속하게<br />현장 조사를 시작합니다
              </p>
            </div>
            <div className="text-center group hover:-translate-y-2 transition-all duration-300">
              <div className="w-20 h-20 bg-[#EC4899]/10 rounded-3xl flex items-center justify-center mb-6 mx-auto group-hover:bg-[#EC4899]/20 transition-colors">
                <i className="ri-shield-check-line text-4xl text-[#EC4899]"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">공정성</h4>
              <p>
                객관적 증거와 전문적 판단으로<br />공정하게 처리합니다
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
